module.exports = __webpack_public_path__ + "img/logo-aqua-1.ad575754.png";